import type { UISchemaElement } from '@jsonforms/core'
import { useMemo } from 'react'

import {
  getStickyItems,
  stickySorter
} from '../../../blocks-renderers/renderers/display/utils'
import { useStickyHeight } from '../../../blocks-renderers/utils/hooks/useStickyHeight'

function flattenElements(elements: any): UISchemaElement[] {
  // If the first element is an array, flatten up to one level
  if (Array.isArray(elements[0])) {
    return elements.slice(0, 4).flatMap((el: any) => el)
  }

  return elements
}

export function useStickyZone(
  elements: UISchemaElement[] = [],
  isMobile: boolean
) {
  const sticky: UISchemaElement[] = useMemo(() => {
    const flat = flattenElements(elements)
    const items = getStickyItems(flat)

    items.sort(stickySorter)

    return items
  }, [elements])

  const hasShopCartSticky = sticky.some(
    (control) => control.type === 'ShopCartControl'
  )
  const { stickyRef, stickyHeight } = useStickyHeight(
    isMobile,
    hasShopCartSticky
  )

  return { sticky, hasShopCartSticky, stickyRef, stickyHeight }
}
